import React, { useState } from 'react';
import { CheckCircle2, Gift, BookOpen, Utensils, ShoppingCart, Calendar, Coffee, ShieldCheck, Zap } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CTAButton } from './CTAButton';
import { UpsellModal } from './UpsellModal';
export function OfferSection() {
  const discountCheckoutUrl = 'https://pay.hotmart.com/F104765975P?off=9ejqig6u&checkoutMode=10';
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);
  const [is72hExpired, setIs72hExpired] = useState(() => {
    const storedEndTime = localStorage.getItem('cenas_offer_72h_end_time');
    if (storedEndTime) {
      return new Date().getTime() > parseInt(storedEndTime, 10);
    }
    return false;
  });
  const handle72hExpire = () => {
    setIs72hExpired(true);
  };
  return <section id="offer-section" className="py-16 md:py-24 px-4 bg-white relative scroll-mt-10" data-id="element-219" data-mp="2t62u2p7pysac">
      <div className="max-w-4xl mx-auto" data-id="element-220" data-mp="2y55n1bafd81y">
        <div className="text-center mb-16" data-id="element-221" data-mp="2y679sd0szizi">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-forest mb-4" data-id="element-222" data-mp="12ojzyn1w6mr1">
            Todo Lo Que Incluye Tu Protocolo Completo
          </h2>
          <p className="text-lg text-dark/60" data-id="element-223" data-mp="sxp3kpuxm6rv">
            El stack de transformación nocturna más completo
          </p>
        </div>

        {/* Main Product */}
        <div className="bg-cream p-6 md:p-8 rounded-2xl border-2 border-forest/20 shadow-sm mb-8 relative overflow-hidden" data-id="element-224" data-mp="oxyd6n9bhsnv">
          <div className="absolute top-0 right-0 bg-forest text-white px-4 py-1 rounded-bl-xl font-bold text-sm" data-id="element-225" data-mp="1gn9x22opomfe">
            PRODUCTO PRINCIPAL
          </div>
          <div className="flex flex-col md:flex-row gap-6 items-center md:items-start" data-id="element-226" data-mp="1ck4uk04mskqr">
            <div className="w-24 h-24 bg-white rounded-xl shadow-sm flex items-center justify-center shrink-0 border border-forest/10" data-id="element-227" data-mp="17ltkppec6a8j">
              <BookOpen size={40} className="text-forest" data-id="element-228" data-mp="146gfhulj8io" />
            </div>
            <div data-id="element-229" data-mp="3sb9aqi5qdux4">
              <h3 className="font-serif text-2xl font-bold text-forest mb-2" data-id="element-230" data-mp="3sewzl408dt5i">
                Cenas Anti-Inflamatorias en 15 Minutos — Guía Maestra (PDF)
              </h3>

              <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-dark/80" data-id="element-231" data-mp="2n6gsc9jaz5y">
                <li className="flex items-start gap-2" data-id="element-232" data-mp="3ksji42b52eki">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-233" data-mp="3oumtys1pzl6b" />{' '}
                  El Método de Digestión en Reposo
                </li>
                <li className="flex items-start gap-2" data-id="element-234" data-mp="3fuhy9f5w2b7z">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-235" data-mp="3fw1g3a770ubv" />{' '}
                  Los 7 Pilares de la Cena
                </li>
                <li className="flex items-start gap-2" data-id="element-236" data-mp="2s4nml0xb2spb">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-237" data-mp="2s55skp9rslaf" />{' '}
                  El sistema del Plato 50-25-25
                </li>
                <li className="flex items-start gap-2" data-id="element-238" data-mp="2di6zyqz6fku4">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-239" data-mp="28jnhx1npet71" />{' '}
                  Los 8 culpables ocultos
                </li>
                <li className="flex items-start gap-2" data-id="element-240" data-mp="2ifyrvkztn6yb">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-241" data-mp="2wgt30be97m0o" />{' '}
                  Guía de especias carminativas
                </li>
                <li className="flex items-start gap-2" data-id="element-242" data-mp="36749o5pbo9b9">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-243" data-mp="368p3tu7q5q8l" />{' '}
                  Protocolo de Timing Digestivo
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-244" data-mp="3a6d1v64prz4p">
          {/* Bonus 1 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-245" data-mp="18gxo3d3kns8s">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-246" data-mp="1dg0js6xnwm43">
              B1
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-247" data-mp="1m9nctpahjb9l">
              <Utensils className="text-gold" size={24} data-id="element-248" data-mp="pkxyg8y2h0sd" />
              <h4 className="font-bold text-lg text-forest" data-id="element-249" data-mp="pmis7wck4fp6">
                Recetario Maestro 21 Cenas
              </h4>
            </div>
            <p className="text-sm text-dark/70 mb-3" data-id="element-250" data-mp="ykkwqlvi1qh7">
              21 recetas organizadas en 4 categorías (Mar, Aves, Vegetales,
              Huevo). Máximo 15 minutos.
            </p>
            <ul className="text-sm text-dark/80 space-y-1" data-id="element-251" data-mp="2a0j32hzalyeq">
              <li className="flex items-center gap-2" data-id="element-252" data-mp="2a23vo221r79y">
                <CheckCircle2 size={14} className="text-success" data-id="element-253" data-mp="2ey2rgappfrke" /> Lista de
                ingredientes exacta
              </li>
              <li className="flex items-center gap-2" data-id="element-254" data-mp="2p29cn3772dc6">
                <CheckCircle2 size={14} className="text-success" data-id="element-255" data-mp="2k3ocf3rxztnq" /> Pasos con
                tiempos reales
              </li>
              <li className="flex items-center gap-2" data-id="element-256" data-mp="2fbwt9eb48q7m">
                <CheckCircle2 size={14} className="text-success" data-id="element-257" data-mp="2bbw4p0uayymu" /> Variante
                rápida de emergencia
              </li>
            </ul>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-258" data-mp="21dggb5mnu3h1">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-259" data-mp="1wedju9kqx5ko">
              B2
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-260" data-mp="1sf4qh5tmb9pn">
              <ShoppingCart className="text-gold" size={24} data-id="element-261" data-mp="3qr3fowuocoup" />
              <h4 className="font-bold text-lg text-forest" data-id="element-262" data-mp="3mr2r4jdv2x9x">
                Checklist de Despensa
              </h4>
            </div>
            <p className="text-sm text-dark/70 mb-3" data-id="element-263" data-mp="1k3cic1dfqt3d">
              Tu mapa de compras definitivo para una cocina anti-inflamatoria.
            </p>
            <ul className="text-sm text-dark/80 space-y-1" data-id="element-264" data-mp="1b3g0ailjwsha">
              <li className="flex items-center gap-2" data-id="element-265" data-mp="1b50w0bjlqhgq">
                <CheckCircle2 size={14} className="text-success" data-id="element-266" data-mp="1f4jel0nyagge" /> Qué eliminar
                hoy mismo
              </li>
              <li className="flex items-center gap-2" data-id="element-267" data-mp="22voutgxszar8">
                <CheckCircle2 size={14} className="text-success" data-id="element-268" data-mp="27tqb5u3ugvz0" /> 25
                ingredientes básicos
              </li>
              <li className="flex items-center gap-2" data-id="element-269" data-mp="1tugzn7ql2q1d">
                <CheckCircle2 size={14} className="text-success" data-id="element-270" data-mp="1tw1qam9s1oty" /> Guía de
                etiquetado en súper
              </li>
            </ul>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-271" data-mp="idh6yb0bq96t">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-272" data-mp="nf6irsvdeqvy">
              B3
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-273" data-mp="auq17zgt7qzp">
              <Calendar className="text-gold" size={24} data-id="element-274" data-mp="ovkcqqz5m82l" />
              <h4 className="font-bold text-lg text-forest" data-id="element-275" data-mp="osy4sq8cpqju">
                Planificador Semanal
              </h4>
            </div>
            <ul className="text-sm text-dark/80 space-y-1 mt-2" data-id="element-276" data-mp="3sbhlqwlkx9zc">
              <li className="flex items-center gap-2" data-id="element-277" data-mp="3s9ofvjisitse">
                <CheckCircle2 size={14} className="text-success" data-id="element-278" data-mp="3ndpkvd2yidj0" /> Plantilla de
                7 días imprimible
              </li>
              <li className="flex items-center gap-2" data-id="element-279" data-mp="5xhgbr4a18ur">
                <CheckCircle2 size={14} className="text-success" data-id="element-280" data-mp="156h6qhd1r39" /> Seguimiento
                de síntomas
              </li>
              <li className="flex items-center gap-2" data-id="element-281" data-mp="39jyjwt3ak1yw">
                <CheckCircle2 size={14} className="text-success" data-id="element-282" data-mp="34mg9ey9mleos" /> Escala de
                inflamación matutina
              </li>
            </ul>
          </div>

          {/* Bonus 4 & 5 Combined */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-283" data-mp="2o1omzo3sxd1v">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-284" data-mp="2t1b2k473r5du">
              B4+5
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-285" data-mp="321pon5rw4oie">
              <Coffee className="text-gold" size={24} data-id="element-286" data-mp="3216guhvyfgi3" />
              <h4 className="font-bold text-lg text-forest" data-id="element-287" data-mp="370ap96b21a7d">
                Infusiones & Ritual
              </h4>
            </div>
            <ul className="text-sm text-dark/80 space-y-1 mt-2" data-id="element-288" data-mp="3bsu74fgryrhz">
              <li className="flex items-center gap-2" data-id="element-289" data-mp="3gr5bwbs7qbtc">
                <CheckCircle2 size={14} className="text-success" data-id="element-290" data-mp="3gsou47xfiwxr" /> 5 infusiones
                post-cena eficaces
              </li>
              <li className="flex items-center gap-2" data-id="element-291" data-mp="3pr0s4v0mkx08">
                <CheckCircle2 size={14} className="text-success" data-id="element-292" data-mp="3prk29pk1ah3p" /> Ritual de
                cierre de 30 min
              </li>
              <li className="flex items-center gap-2" data-id="element-293" data-mp="1a2d49e1s7xlc">
                <CheckCircle2 size={14} className="text-success" data-id="element-294" data-mp="1a1k3ctpi82b4" /> Respiración
                4-7-8 anti-cortisol
              </li>
            </ul>
          </div>
        </div>

        {/* SUPER LLAMATIVA OFFER STACK */}
        <div id="offer-stack" className="bg-forest rounded-3xl p-1 shadow-2xl relative overflow-hidden mt-20 scroll-mt-6" data-id="element-295" data-mp="106a58h288f2m">
          <div className="absolute inset-0 bg-gradient-to-r from-gold via-white to-gold opacity-30 animate-[spin_4s_linear_infinite] scale-150" data-id="element-296" data-mp="1ssl49na6q7xb"></div>

          <div className="bg-cream rounded-[22px] p-6 md:p-10 relative z-10" data-id="element-297" data-mp="1o01tey2vtqw7">
            <div className="text-center mb-8" data-id="element-298" data-mp="1j2ia3jrbunxe">
              <h3 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-2" data-id="element-299" data-mp="2gi5qcf1mxlat">
                Resumen de tu Inversión
              </h3>
              <p className="text-dark/60" data-id="element-300" data-mp="2bq4id5bi2gql">Todo lo que te llevas hoy</p>
            </div>

            <div className="space-y-3 mb-8 max-w-lg mx-auto" data-id="element-301" data-mp="3vhlyog1ccqsv">
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-302" data-mp="3qi9c7wedtlqt">
                <span className="text-dark/80 font-medium" data-id="element-303" data-mp="9a5jjuplhupv">
                  Guía Maestra Anti-Inflamatoria
                </span>
                <span className="text-dark/50 line-through" data-id="element-304" data-mp="49q8j9ssczb2">$88.645 ARS</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-305" data-mp="i8zoq9gzrtf1">
                <span className="text-dark/80 font-medium" data-id="element-306" data-mp="dag0u3iu87k1">
                  Recetario Maestro 21 Cenas
                </span>
                <span className="text-dark/50 line-through" data-id="element-307" data-mp="rzc9o2spxolp">$50.924 ARS</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-308" data-mp="n1sqcoh5ylmw">
                <span className="text-dark/80 font-medium" data-id="element-309" data-mp="1111w0u7qtxcm">
                  Checklist Despensa
                </span>
                <span className="text-dark/50 line-through" data-id="element-310" data-mp="wxdoucn0x3rw">$32.063 ARS</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-311" data-mp="1flo7uiobethg">
                <span className="text-dark/80 font-medium" data-id="element-312" data-mp="1kk7smfr69z88">
                  Planificador Semanal
                </span>
                <span className="text-dark/50 line-through" data-id="element-313" data-mp="1blni41vrmvv3">$22.633 ARS</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-314" data-mp="wx9evpuft5e0">
                <span className="text-dark/80 font-medium" data-id="element-315" data-mp="11ng3vqsv2rws">
                  Guía de Infusiones
                </span>
                <span className="text-dark/50 line-through" data-id="element-316" data-mp="nx49tmcpuj30">$32.063 ARS</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-317" data-mp="rx4zk359mgpd">
                <span className="text-dark/80 font-medium" data-id="element-318" data-mp="dxvhexxi1cir">
                  Ritual de Cierre 30 Minutos
                </span>
                <span className="text-dark/50 line-through" data-id="element-319" data-mp="iwoy0z831jn5">$32.063 ARS</span>
              </div>
              <div className="flex justify-between items-center pt-2" data-id="element-320" data-mp="2knyudzx0x6jz">
                <span className="text-forest font-bold text-lg" data-id="element-321" data-mp="2fvfg10qii7e4">
                  VALOR TOTAL REAL:
                </span>
                <span className="text-urgency font-bold text-xl line-through" data-id="element-322" data-mp="2buvhptu7cxqe">
                  $258.390 ARS
                </span>
              </div>
            </div>

            {/* PRICING BOX — SINGLE PHASE */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-gold text-center relative" data-id="element-323" data-mp="33kgscz2gu2oo">
              <p className="text-dark/70 font-medium mb-2 mt-2" data-id="element-324" data-mp="2zhtyytq5c9pd">
                Precio Especial Por Tiempo Limitado:
              </p>

              <div className="flex flex-col items-center gap-1 mb-6" data-id="element-325" data-mp="2pma48anbjh27">
                <div className="flex items-center gap-3" data-id="element-326" data-mp="1j5ev5ct9kb23">
                  <span className="text-lg text-dark/30 line-through font-medium" data-id="element-327" data-mp="1j6zrn7z5242l">
                    Valor real: $258.390
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-328" data-mp="1436eezx5vxhy">
                  <span className="text-2xl text-dark/40 line-through font-bold" data-id="element-329" data-mp="140k62y2g5dyo">
                    Precio regular: $54.696
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-2" data-id="element-330" data-mp="1dz01vecf5bei">
                  <span className="text-sm text-success font-semibold uppercase tracking-wide" data-id="element-331" data-mp="1irjd44nmvug5">
                    DIPOSIBLE HOY SOLO POR:
                  </span>
                </div>
                <button type="button" onClick={() => setIsUpsellOpen(true)} aria-label="Ver opciones de compra por 26.499 pesos argentinos" className="text-6xl md:text-7xl font-serif font-bold text-success drop-shadow-sm rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2" data-id="element-332" data-mp="1rrppfn7liodq">
                  $26.499 <span className="text-2xl text-success/70" data-id="element-333" data-mp="7cxfhgs20pt5">ARS</span>
                </button>
              </div>

              <div className="bg-forest/5 rounded-xl p-4 mb-8 text-sm text-dark/80 flex items-center justify-center gap-2" data-id="element-334" data-mp="1xrol78e3a9zw">
                <Gift size={18} className="text-gold" data-id="element-335" data-mp="1swhlscrurrgs" />
                <span data-id="element-336" data-mp="26smr5w838rl4">
                  Incluye derecho a{' '}
                  <strong data-id="element-337" data-mp="21v33y6tex4h1">recibir todas las actualizaciones futuras</strong>{' '}
                  gratis.
                </span>
              </div>

              {!is72hExpired && <CountdownTimer theme="light" className="mb-8" storageKey="cenas_offer_72h_end_time" durationMs={72 * 60 * 60 * 1000} onExpire={handle72hExpire} data-id="element-338" data-mp="1a3niig3ldnse" />}

              <CTAButton text="SÍ, QUIERO DESINFLAMARME HOY" onClick={() => setIsUpsellOpen(true)} variant="urgency" className="text-xl md:text-2xl py-5" showTrust={false} data-id="element-339" data-mp="1j28zi6tf0ur2" />

              <p className="text-xs text-dark/50 mt-4" data-id="element-340" data-mp="32288h0buan0r">
                Acceso inmediato • Descarga instantánea • Garantía 30 días
              </p>

              {/* Mercado Pago */}
              <div className="mt-6 pt-6 border-t border-forest/10 flex flex-col items-center gap-2" data-id="element-341" data-mp="2t3ebh8uljumo">
                <p className="text-xs text-dark/60 font-medium" data-id="element-342" data-mp="2y2higyu50axa">
                  Pago disponible con
                </p>
                <button type="button" onClick={() => setIsUpsellOpen(true)} aria-label="Ver opciones de compra con Mercado Pago" className="rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2" data-id="element-343" data-mp="3lrsbtv95r31e">
                  <img src="https://cdn.magicpatterns.com/uploads/qhpGf2YGATQAhMnp28H3Ro/Mercado_Pago.svg.png" alt="Mercado Pago" className="h-16 sm:h-[4.5rem] w-auto object-contain" data-id="element-344" data-mp="20dxm6k29wtuo" />
                </button>
              </div>

              {/* Trust badges */}
              <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-345" data-mp="1hacet4bngjo7">
                <div className="flex items-center gap-2 text-sm text-dark/80 font-medium" data-id="element-346" data-mp="1cgrnfv4kanxz">
                  <div className="bg-success/10 p-2 rounded-full" data-id="element-347" data-mp="17ig9b878hr9y">
                    <ShieldCheck size={18} className="text-success" data-id="element-348" data-mp="12kocq0vn9gzf" />
                  </div>
                  <span data-id="element-349" data-mp="xkk4ey4w3ska">Garantía 30 días</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-dark/80 font-medium" data-id="element-350" data-mp="xnenomc637c4">
                  <div className="bg-forest/10 p-2 rounded-full" data-id="element-351" data-mp="tlkraq908phr">
                    <Zap size={18} className="text-forest" data-id="element-352" data-mp="olownhm76aev" />
                  </div>
                  <span data-id="element-353" data-mp="2nxreknf6awqf">Acceso inmediato post-pago</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <UpsellModal isOpen={isUpsellOpen} onClose={() => setIsUpsellOpen(false)} baseCheckoutUrl={discountCheckoutUrl} data-id="element-354" data-mp="2iwk60m57htip" />
    </section>;
}